import { ApiService } from '@shared/services';
import { IPEPService } from '@shared/interfaces/services';
import { PEPConfigurationModel, PEPContentModel } from '@shared/models/PersonalEducationPlan';

export class PEPService extends ApiService implements IPEPService {
    constructor() {
        super('/personalEducationPlan/parent');
    }

    getConfigurations(): Promise<PEPConfigurationModel[]> {
        return this.get('/getConfigurations');
    }

    getAvailableContent(): Promise<PEPContentModel[]> {
        return this.get('/getAvailableContent');
    }

    deleteConfiguration(entries: PEPConfigurationModel[]): Promise<any> {
        const deleteQuery = entries.map((x: PEPConfigurationModel) => `&ids=${x.id}`)
            .join()
            .substring(1);
        return this.delete(`/deleteConfiguration?${deleteQuery}`);
    }

    updateConfiguration(params: PEPConfigurationModel): Promise<any> {
        return this.put('/updateConfiguration', params);
    }

    addConfiguration(params: PEPConfigurationModel): Promise<any> {
        return this.post('/addConfiguration', params);
    }
}
